import { h, Component } from 'preact';
import Store from 'store/store';
import s from 'components/bolt/downWorld/downWorld.sss';
import SlotMachineStrips from 'components/bolt/downWorld/slotMachineStrips/slotMachineStrips.js';
import Lever from 'components/bolt/downWorld/lever/lever.js';
import WinResult from 'components/bolt/downWorld/winResult/winResult.js';
import SlotMachineWinEffects from 'components/bolt/downWorld/slotMachineWinEffects/slotMachineWinEffects.js';
// import Poster from 'components/bolt/downWorld/poster/poster.js';
import { joinClasses } from 'utils/utils';
import { slotMachineIconIds } from 'helpers/downWorldData.js';
import EasterEgg from './easterEgg';

const { poisonMushroom, boomerangFlower, powerUpMushroom } = slotMachineIconIds;

export default class DownWorld extends Component {
	constructor(props) {
		super(props);
		this.state = {
			winningIcon: null,
			posterOpen: false,
			lastWinningIcon: null,
			easterEggOpen: false,
			easterEggNum: 0
		};
		this.onLeverPull = this.onLeverPull.bind(this);
		this.onLeverHover = this.onLeverHover.bind(this);
		this.onLeverUnhover = this.onLeverUnhover.bind(this);
		this.onSlotMachineWin = this.onSlotMachineWin.bind(this);
		this.onSlotMachineAnimComplete = this.onSlotMachineAnimComplete.bind(this);
		this.toggleEasterEgg = this.toggleEasterEgg.bind(this);
		this.setEasterEgg = this.setEasterEgg.bind(this);
		// this.closePoster = this.closePoster.bind(this);
	}

	componentDidMount() {
		Store.on('SLOT_MACHINE_WIN', this.onSlotMachineWin);
		Store.on('SLOT_MACHINE_ANIM_COMPLETE', this.onSlotMachineAnimComplete);
	}

	componentWillUnmount() {
		Store.off('SLOT_MACHINE_WIN', this.onSlotMachineWin);
		Store.off('SLOT_MACHINE_ANIM_COMPLETE', this.onSlotMachineAnimComplete);
		this.slotMachineAnimTimer && clearTimeout(this.slotMachineAnimTimer);
		// this.posterTimer && clearTimeout(this.posterTimer);
		this.slotMachineGrowTimer && clearTimeout(this.slotMachineGrowTimer);
	}

	onLeverPull() {
		if (this.slotMachineAnimating) return;

		// tie these videos to the user gesture so they can play later without browser restrictions
		const vids = [
			'slot-coin-stack-video',
			'slot-ice-top-video',
			'slot-ice-bottom-video',
			'slot-fire-top-video',
			'slot-fire-bottom-video',
			'slot-fire-left-video',
			'slot-fire-right-video',
			'slot-yoshi-egg-video'
		];
		vids.forEach(id => {
			const video = document.getElementById(id);
			video && video.load();
		});

		const { winningIcon } = this.state;
		this.setState({
			lastWinningIcon: winningIcon,
			winningIcon: null
		});
		this.slotMachineAnimating = true;
		Store.emit('SLOT_MACHINE_PULL');
		Store.emit('PLAY_SOUND', 'slotMachineLever');
	}

	onLeverHover() {
		if (Date.now() - this.leverPeekedTime < 200) return;
		if (this.slotMachineAnimating) return;
		this.leverPeekedTime = Date.now();
		Store.emit('HOVER_LEVER');
	}

	onLeverUnhover() {
		if (this.slotMachineAnimating) return;
		Store.emit('UNHOVER_LEVER');
	}

	onSlotMachineLoad() {
		Store.emit('SLOT_MACHINE_LOADED');
	}

	onSlotMachineWin (winningIcon) {
		this.setState({ winningIcon });
		if (winningIcon === boomerangFlower) {
			this.setState({
				slotMachineForward: true
			});
			const isDesktop = this.props?.client?.isDesktopWidth;
			this.slotMachineAnimTimer = setTimeout(() => {
				this.setState({ slotMachineForward: false });
			}, isDesktop ? (800 + 3000 + 2000) : (800 + 1250)); // initial pause + anim delay (none on mobile) + half of anim duration
		}
		if (winningIcon === powerUpMushroom) {
			this.setState({ slotMachineGrow: true });
			this.slotMachineGrowTimer = setTimeout(() => {
				this.setState({ slotMachineGrow: false });
			}, 3900);
		}
		// if (winningIcon === yoshiEgg) {
		// 	this.posterTimer = setTimeout(() => {
		// 		this.pauseMusic();
		// 		this.setState({ posterOpen: true });
		// 	}, 800);
		// }
	}

	onSlotMachineAnimComplete() {
		this.slotMachineAnimating = false;
	}

	pauseMusic() {
		Store.emit('PAUSE_MUSIC');
		this.downWorldMusicPaused = true;
	}

	resumeMusic() {
		if (this.downWorldMusicPaused) {
			Store.emit('RESUME_MUSIC');
			this.downWorldMusicPaused = false;
		}
	}

	// closePoster() {
	// 	this.setState({ posterOpen: false });
	// 	this.resumeMusic();
	// 	this.onSlotMachineAnimComplete();
	// }

	setEasterEgg(easterEggNum) {
		this.setState({ easterEggNum: easterEggNum });
		if (!this.state.easterEggOpen) {
			this.toggleEasterEgg();
		}
	}

	toggleEasterEgg() {
		this.setState({ easterEggOpen: !this.state.easterEggOpen });
	}

	render() {
		const { imageRoot, videoRoot, downWorldFound, showScrollArea, client, copy } = this.props;
		const { winningIcon, lastWinningIcon, slotMachineForward, slotMachineGrow, posterOpen, easterEggOpen, easterEggNum} = this.state;
		const showWoozy = winningIcon === poisonMushroom;

		return (
			<div
				class={joinClasses (s.container, downWorldFound && s.downWorldFound, showWoozy && s.woozy)}
				id ="downWorld-container"
			>
				{showScrollArea && <div class={joinClasses(s.scrollArea, downWorldFound && s.downWorldFound )} id ="scrollArea-container" />}
				<img src={`${imageRoot}/down/eqzpl2.webp`} class={joinClasses(s.background, downWorldFound && s.show)} />
				{downWorldFound && (
					<div class={joinClasses(s.downWorld, downWorldFound && s.show)}>
						<div class={s.fade} />
						<div class={s.bottom} />
						<div class={
							joinClasses(
								s.slotMachineContainer,
								slotMachineForward && s.forward,
								slotMachineGrow && s.grow
							)}
						>
							<button
								class={s.leverPull}
								onClick={this.onLeverPull}
								onMouseEnter={this.onLeverHover}
								onMouseLeave={this.onLeverUnhover}
							>
								<Lever imageRoot={imageRoot} />
							</button>
							<SlotMachineStrips imageRoot={imageRoot} />
							<img class={s.slotMachine} src={`${imageRoot}/down/slot-machine.webp`} onLoad={this.onSlotMachineLoad} />
							<WinResult
								imageRoot={imageRoot}
								winningIcon={winningIcon}
								lastWinningIcon={lastWinningIcon}
							/>
						</div>
						{/* <Poster
							name="Yoshi"
							assetSrc={`${videoRoot}/down/yoshi-egg-reveal.webm`}
							videoPoster={`${videoRoot}/down/yoshi-egg-reveal.webp`}
							imageRoot={imageRoot}
							client={client}
							open={posterOpen}
							closePoster={this.closePoster}
						/> */}

						<SlotMachineWinEffects
							imageRoot={imageRoot}
							videoRoot={videoRoot}
							winningIcon={winningIcon}
							client={client}
							setEasterEgg={this.setEasterEgg}
						/>

						<EasterEgg
							imageRoot={imageRoot} 
							videoRoot={videoRoot} 
							copy={copy} 
							isOpen={easterEggOpen} 
							easterEggNum={easterEggNum} 
							onClose={easterEggOpen && this.toggleEasterEgg} 
						/>
					</div>
				)}
			</div>
		);
	}
}

